import { isCubemap } from './utils';

export { CubemapAdapter } from './CubemapAdapter';
export * from './model';
export const cubemapUtils = { isCubemap };
